/**
 * Pave API
 * Pave API Documentation
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { PublicConfig } from '../model/models';


import { Configuration }                                     from '../configuration';



export interface PublicConfigServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * 
     * 
     */
    publicConfigControllerGetPublicConfig0(extraHttpRequestParams?: any): Observable<PublicConfig>;

    /**
     * 
     * 
     */
    publicConfigControllerGetPublicConfig1(extraHttpRequestParams?: any): Observable<PublicConfig>;

}
